import api from './api';

/**
 * GET /api/notifications?status=...&page=...&size=...
 * Returns the inner data envelope: { items, page, size, totalElements, totalPages, hasNext }.
 */
export async function listNotifications({ status = 'all', page = 0, size = 20 } = {}) {
  const { data } = await api.get('/notifications', { params: { status, page, size } });
  return data.data;
}

/** GET /api/notifications/unread-count → number */
export async function getUnreadCount() {
  const { data } = await api.get('/notifications/unread-count');
  return data.data.count;
}

/** POST /api/notifications/{id}/read → updated NotificationDTO */
export async function markNotificationRead(id) {
  const { data } = await api.post(`/notifications/${id}/read`);
  return data.data;
}

/** POST /api/notifications/mark-all-read → { count } */
export async function markAllNotificationsRead() {
  const { data } = await api.post('/notifications/mark-all-read');
  return data.data;
}

/** DELETE /api/notifications/{id} → void */
export async function deleteNotification(id) {
  await api.delete(`/notifications/${id}`);
}

/** DELETE /api/notifications?status=read → { count } */
export async function deleteAllReadNotifications() {
  const { data } = await api.delete('/notifications', { params: { status: 'read' } });
  return data.data;
}
